import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchSilosAssignmentGrid({ siloAssignmentParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `assignment/dashboard/${siloAssignmentParams.factoryId}`,
      params: { groupId: siloAssignmentParams.groupId },
    });
    const siloAssignmentGrid = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSilosAssignmentGrid({ siloAssignmentGrid }));
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

function* addOrUpdateAssignment({ assignmentData, actionName, siloAssignmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: 'assignment',
      data: assignmentData,
    });
    yield put(Actions.fetchSilosAssignmentGrid({ siloAssignmentParams }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* allocateRawMaterial({ allocationData, actionName }) {
  try {
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'materialAllocation',
      data: allocationData,
    });
    const siloAssignmentParams = { factoryId: allocationData.factoryId };
    const materialAllocationParams = { assignmentId: allocationData.assignmentId };
    yield put(Actions.fetchSilosAssignmentGrid({ siloAssignmentParams }));
    yield put(Actions.fetchAllocatedRawMaterial({ materialAllocationParams }));
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

function* fetchAllocatedRawMaterial({ materialAllocationParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'materialAllocation/getSearched/',
      params: materialAllocationParams,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    const materialAllocations = data;
    yield put(Actions.setAllocatedRawMaterial({ materialAllocations }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* deleteAllocatedRawMaterial({ allocatedMaterial }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: 'materialAllocation/' + allocatedMaterial.id,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    const materialAllocationParams = { assignmentId: allocatedMaterial.assignmentId };
    yield put(Actions.fetchAllocatedRawMaterial({ materialAllocationParams }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* completeAssignment({ assignment }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'assignment',
      data: assignment,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    const siloAssignmentParams = { factoryId: assignment.factoryId };
    yield put(Actions.fetchSilosAssignmentGrid({ siloAssignmentParams }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* deleteAssignment({ assignment }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: 'assignment/' + assignment.id,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    const siloAssignmentParams = { factoryId: assignment.factoryId };
    yield put(Actions.fetchSilosAssignmentGrid({ siloAssignmentParams }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* fetchMaterialConsumption({ materialConsumptionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'materialConsumption/getConsumption/' + materialConsumptionParams.assignmentId,
      params: materialConsumptionParams,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    const materialConsumptions = data;
    yield put(Actions.setMaterialConsumption({ materialConsumptions }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* deleteMaterialConsumpton({ materialConsumption }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: 'materialConsumption/' + materialConsumption.id,
    });
    const materialConsumptionParams = { assignmentId: materialConsumption.assignmentId };
    yield put(Actions.fetchMaterialConsumption({ materialConsumptionParams }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_SILOS_ASSIGNMENT_GRID, fetchSilosAssignmentGrid),
    takeLatest(ActionTypes.ADD_OR_UPDATE_ASSIGNMENT, addOrUpdateAssignment),
    takeLatest(ActionTypes.ALLOCATE_RAW_MATERIAL, allocateRawMaterial),
    takeLatest(ActionTypes.FETCH_ALLOCATED_RAW_MATERIAL, fetchAllocatedRawMaterial),
    takeLatest(ActionTypes.DELETE_ALLOCATED_RAW_MATERIAL, deleteAllocatedRawMaterial),
    takeLatest(ActionTypes.COMPLETE_ASSIGNMENT, completeAssignment),
    takeLatest(ActionTypes.DELETE_ASSIGNMENT, deleteAssignment),
    takeLatest(ActionTypes.FETCH_MATERIAL_CONSUMPTION, fetchMaterialConsumption),
    takeLatest(ActionTypes.DELETE_MATERIAL_CONSUMPTION, deleteMaterialConsumpton),
  ]);
}
